import { lazy, type FC, type ReactElement, Suspense } from 'react'

import { Loader } from '../components/Loader'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const LazyTrustedDeviceManagementPage = lazy(() =>
  import('../pages/TrustedDeviceManagement/TrustedDeviceManagementPage').then((module) => ({
    default: module.TrustedDeviceManagementPage,
  })),
)

export const TrustedDeviceManagementIOSRoute: FC = (): ReactElement => {
  const platform = 'ios'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  return (
    <Suspense fallback={<Loader />}>
      <LazyTrustedDeviceManagementPage showBackButton={false} />
    </Suspense>
  )
}
